import appConfig from '@/config/global-config'
import fetcher from '@/services/fetcher'
import { buildQueryV2 } from '@/utils/helpers'

// GraphQL Query cho blog posts theo schema mới
const GET_LIST_BLOG_POSTS = `
query getListBlogPosts($postId: Int, $pageSize: Int, $currentPage: Int, $action: String!, $sortBy: String, $categoryId: Int, $filter:PostsFilterInput) {
  mpBlogPosts(
    postId: $postId
    pageSize: $pageSize
    currentPage: $currentPage
    action: $action
    sortBy: $sortBy
    categoryId: $categoryId
    filter: $filter
  ) {
    items {
      categories {
        items {
          category_id
          name
          url_key
          path
        }
      }
      ...PostFields
    }
    pageInfo {
      currentPage
      endPage
      hasNextPage
      hasPreviousPage
      pageSize
      startPage
    }
    total_count
  }
}

fragment PostFields on Post {
  created_at
  enabled
  image
  name
  post_content
  author_name
  post_id
  publish_date
  url_key
  short_description
  store_ids
  updated_at
  album_images {
    alt
    image
  }
}
`

export const getBlogPostsByCategory = async (
  params: {
    categoryId?: number
    action?: string
    pageSize?: number
    currentPage?: number
    sortBy?: string
    postId?: number
    filter?: any
  },
  locale?: string
) => {
  try {
    const {
      categoryId,
      action = 'get_post_by_categoryId',
      pageSize = 10,
      currentPage = 1,
      sortBy,
      postId,
      filter,
    } = params

    const variables = {
      categoryId,
      action,
      pageSize,
      currentPage,
      ...(sortBy && { sortBy }),
      ...(postId && { postId }),
      ...(filter && { filter }),
    }

    const response = await fetcher.get(buildQueryV2(GET_LIST_BLOG_POSTS, variables), {
      next: {
        revalidate: 120,
        tags: [`blog-posts-category-${categoryId}`, action, `${categoryId}-${pageSize}-${currentPage}`],
      },
      locale: locale || appConfig.defaultLocale,
    })

    const data = response?.payload?.data?.mpBlogPosts as IBlogPostsResponse
    if (response?.payload?.errors) {
      return { status: 'error', message: response.payload.errors[0]?.message, data: null }
    }

    return { status: 'success', data, message: 'Lấy danh sách bài viết thành công' }
  } catch (error) {
    console.error('Error fetching blog posts:', error)
    return { status: 'error', message: 'Có lỗi xảy ra khi tải bài viết', data: null }
  }
}
